import { ModelError } from './ModelError';

export const UNHANDLED_ERROR_NAME = 'UNHANDLED_ERROR';

export class UnhandledError extends ModelError {
  public readonly name: string = UNHANDLED_ERROR_NAME;
}
